module.exports = __webpack_public_path__ + "img/icone-relogio.0568815b.svg";